module.exports = __webpack_public_path__ + "media/icons/close-button-f10ecf27.png";